import {createAsyncThunk} from '@reduxjs/toolkit';
import {ThunkConfig} from "../../../../config/StateSchema";
import {BaseResponse} from "../../../../../api/api";
import {snackbarAction} from "../../../../errors/SnackbarSlice";
import {IRoomRequest} from "../../../../rooms/types/roomsTypes";


export interface IResponse {
    collection: IRoomRequest[]
}


export const fetchNotificationsRequestsRoom = createAsyncThunk<
    number,
    void,
    ThunkConfig<string>
>(
    'notifications/fetchNotificationsRequestsRoom',
    async (_, thunkAPI) => {
        const {extra, rejectWithValue, dispatch} = thunkAPI;
        try {
            const response = await extra.api.get<BaseResponse<IResponse>>('room/request/collection', {
                params: {
                    status: 0
                }
            })
            if (!response.data.success) {
                return rejectWithValue('error')
            }

            return response.data.response.collection.length
        } catch (err) {
            dispatch(snackbarAction.addError('INTERNAL_ERROR'))
            return rejectWithValue('error');
        }
    }
);
